import styled from 'styled-components';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const ViewStylVdBtn = styled(Button)`
  font-size: 12px;
  font-weight: 500;
  line-height: 110%;
  color: #000;
  width: 129px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background: #fff;

  // 렌더링 이슈로 SVG를 base64로 인코딩된 이미지로 사용
  &:before {
    content: '';
    display: inline-block;
    width: 12px;
    height: 12px;
    margin-right: 4px;
    background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M2.68187 11.521L10.417 6.98061C10.5778 6.89334 10.7197 6.76499 10.8255 6.59891C10.9374 6.42241 10.9939 6.2267 10.9994 6.03217C11.0049 5.85919 10.9702 5.68328 10.8914 5.51884C10.8044 5.33563 10.6666 5.17396 10.4831 5.05704L3.56188 0.654316C3.04027 0.323422 2.35091 0.47738 2.02001 0.996699C1.89742 1.18995 1.84138 1.40623 1.84581 1.61877C1.84555 1.62823 1.84542 1.63771 1.84542 1.64723V8.82903L4.25819 7.33539V3.7435L7.74512 5.95972L1.55132 9.59537C1.02051 9.90788 0.841277 10.5926 1.15379 11.1235C1.3606 11.4773 1.73285 11.6749 2.1166 11.6749C2.30962 11.6749 2.50494 11.6244 2.68187 11.521Z' fill='url(%23paint0_linear_268_3301)' fill-opacity='0.8'/%3E%3Cdefs%3E%3ClinearGradient id='paint0_linear_268_3301' x1='6' y1='0.479874' x2='6' y2='11.6749' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FF3D22'/%3E%3Cstop offset='1' stop-color='%23F01478'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E%0A");
  }

  @media ${({ theme }) => theme.media.smMax} {
    font-size: ${mixin.pxToVw('12')};
    width: ${mixin.pxToVw('129')};
    height: ${mixin.pxToVw('28')};
    border-radius: ${mixin.pxToVw('4')};

    &:before {
      width: ${mixin.pxToVw('12')};
      height: ${mixin.pxToVw('12')};
      margin-right: ${mixin.pxToVw('4')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    font-size: 13px;
    width: 139px;
    height: 30px;

    svg {
      width: 14px;
      height: 14px;
    }

    &:before {
      width: 14px;
      height: 14px;
    }
  }
`;
